import React, { useState, useEffect } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/button';
import { brandData } from '../data/mock';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-700 ${
        isScrolled 
          ? 'bg-[#fffef9]/95 backdrop-blur-sm shadow-sm py-4' 
          : 'bg-transparent py-6'
      }`}
    >
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div 
            className="cursor-pointer"
            onClick={() => scrollToSection('hero')}
          >
            <img 
              src={brandData.mainBrand.logo}
              alt="DRM Kitchen"
              className="h-14 md:h-16 w-auto object-contain"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-12">
            <button 
              onClick={() => scrollToSection('hero')}
              className="text-sm tracking-widest uppercase text-[#4a4a4a] hover:text-[#c9a962] transition-colors duration-300"
            >
              Ana Sayfa
            </button>
            <button 
              onClick={() => scrollToSection('brands')}
              className="text-sm tracking-widest uppercase text-[#4a4a4a] hover:text-[#c9a962] transition-colors duration-300"
            >
              Markalar
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="text-sm tracking-widest uppercase text-[#4a4a4a] hover:text-[#c9a962] transition-colors duration-300"
            >
              İletişim
            </button>
          </nav>

          {/* Phone */}
          <a 
            href={`tel:${brandData.contact.phone.replace(/\s/g, '')}`}
            className="hidden lg:flex items-center gap-2 text-sm text-[#1a1a1a] hover:text-[#c9a962] transition-colors"
          >
            <Phone size={16} strokeWidth={1.5} />
            <span className="tracking-wide">{brandData.contact.phone}</span>
          </a>

          {/* Mobile Menu Button */}
          <Button
            variant="ghost"
            size="icon"
            className="md:hidden text-[#1a1a1a]"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={24} strokeWidth={1.5} /> : <Menu size={24} strokeWidth={1.5} />}
          </Button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-6 pb-6 animate-fade-in">
            <div className="divider mb-6"></div>
            <nav className="flex flex-col space-y-4">
              <button 
                onClick={() => scrollToSection('hero')}
                className="text-left text-sm tracking-widest uppercase text-[#4a4a4a] py-2"
              >
                Ana Sayfa
              </button>
              <button 
                onClick={() => scrollToSection('brands')}
                className="text-left text-sm tracking-widest uppercase text-[#4a4a4a] py-2"
              >
                Markalar
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="text-left text-sm tracking-widest uppercase text-[#4a4a4a] py-2"
              >
                İletişim
              </button>
              <div className="divider my-4"></div>
              <a 
                href={`tel:${brandData.contact.phone.replace(/\s/g, '')}`}
                className="flex items-center gap-2 text-sm text-[#c9a962]"
              >
                <Phone size={16} strokeWidth={1.5} />
                <span>{brandData.contact.phone}</span>
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};
